import { useRouter } from "next/router";
import config from "@/lib/config";
import routes from "./routes";
export default function isShowValuePlanLabel(_ref) {
  let {
    channelId
  } = _ref;
  const router = useRouter();
  const valuePlanId = config.valuePlanId.vod;
  const showValuePlanLabel = channelId === valuePlanId && router.asPath !== routes.valuePlan;
  return showValuePlanLabel;
}